// Which 0065 actions the signed-in member's roles (GET /v1/me `roles`)
// allow, mirrored from the role matrix (cmd/core-platform/role_matrix.go,
// migration 0064). This only decides what the portal SHOWS: the server
// refuses anything else (403 insufficient_role {required_roles}), and the
// SQL re-checks the same roles (account_lifecycle.go:15-17), so a stale
// role list is still explained, never trusted.

function hasAny(roles: readonly string[], allowed: readonly string[]): boolean {
  return roles.some((r) => allowed.includes(r));
}

/** actPayoutRefund (role_matrix.go:100; routes :219-220): change the destination, get its onboarding link. */
export const PAYOUT_DESTINATION_ROLES = ["owner", "payout_approver"] as const;
export function canChangePayoutDestination(roles: readonly string[]): boolean {
  return hasAny(roles, PAYOUT_DESTINATION_ROLES);
}

/** actMembers (role_matrix.go:104; routes :221, :223): read the closure blockers, download the export. */
export const CLOSURE_READ_ROLES = ["owner", "admin"] as const;
export function canReadClosure(roles: readonly string[]): boolean {
  return hasAny(roles, CLOSURE_READ_ROLES);
}
export const canExportRecords = canReadClosure;

/** actCloseAccount (role_matrix.go:106; route :222): close the account. */
export const CLOSE_ACCOUNT_ROLES = ["owner"] as const;
export function canCloseAccount(roles: readonly string[]): boolean {
  return hasAny(roles, CLOSE_ACCOUNT_ROLES);
}
